import styled from 'styled-components';
import Typography from '@material-ui/core/Typography';

const TypographyTitle = styled(Typography)`
  text-align: center;
  padding-top: 30px;
`;

export default TypographyTitle;
